<template>
    <div>
        <card-header title="Discount Codes" icon="fa-tags"></card-header>

        <card-toolbar>
            <button @click="$openCard('conf-new-discount', {confId: props.confId}, card)"><i class="far fa-plus"></i>New Registration Discount</button>
        </card-toolbar>

        <card-body>
            <card-list>
                <conf-discount-tile
                    :card="card"
                    :discount="discount"
                    v-for="discount in discounts"
                    @click="$openCard('conf-edit-discount', {confId: discount.conference_id, discountId: discount.id}, card)"
                    :active="(child && child.definition.component === 'conf-edit-discount' && discount.id === parseInt(child.props.discountId))"
                />
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import CardToolbar from "@/TIER/components/CardToolbar";

    import {client as http} from '@/http_client';
    import ConfDiscountTile from "../../../components/tiles/ConfDiscountTile";

    export default {
        components: {ConfDiscountTile, CardToolbar, CardList, CardHeader, CardBody},
        props: ['card', 'props', 'child'],
        data() {
            return {
                discounts: []
            };
        },
        methods: {
            loadConference: function(force) {
                this.$emit('loading', true);
                http.get('/conferences/' + this.props.confId + '/discounts', {force}).then(response => {
                    this.discounts = response.data;
                    this.$emit('loading', false);
                }).catch(err => {

                });
            },
            reload: function() {
                this.loadConference(true);
            }
        },
        mounted() {
            this.loadConference();
        }
    };
</script>

<style>

</style>
